import React, { useState, useEffect } from 'react';
import { Link, Redirect, useHistory } from 'react-router-dom';
import Sidebar from '../../../Components/Sidebar/Sidebar';
import axios from 'axios';

import verificandoToken from '../../../../FuncoesGerais/VerificarToken';
import verificandoApp from '../../../../FuncoesGerais/verificaApp';
import { ensureProtocol } from '../../../../config/backend';

import '../../styles/inventario.css';
import './Desvinculacao.css';

function NovoDesvinculo(props) {

    const history = useHistory();

    const [data, setData] = useState([]);

    const [selected, setSelected] = useState("");
    const [codUsu, setCodUsu] = useState("");
    const [nomUsu, setNomUsu] = useState("-");
    const [seqVin, setSeqVin] = useState("");

    const [obsVin, setObsVin] = useState('');

    const [mensagem, setMensagem] = useState('');
    const [sucesso, setSucesso] = useState('N');
    const [sitVin, setSitVin] = useState('I');

    const pegarHardware = async (e) => {
        verificandoToken();

        const token = localStorage.getItem('token');

        try {
            const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/hardware/ativos/ComVinculo", {
                headers: {
                    Authorization: `${token}`
                }
            });
            const raw = Array.isArray(response.data) ? response.data : [];
            const listaHardware = raw.map((r) => ({
                codHar: r.CODHAR ?? r.codHar,
                serEqp: (r.SEREQP ?? r.serEqp ?? '').toString(),
                patEqp: (r.PATEQP ?? r.patEqp ?? '').toString(),
                nomEqp: (r.NOMEQP ?? r.nomEqp ?? '').toString(),
                codUsu: r.CODUSU ?? r.codUsu
            }));
            setData(listaHardware);
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
        }
    };

    const pegarUsuarios = async (codHar) => {

        verificandoToken();

        const token = localStorage.getItem('token');

        try {
            const response = await axios.get(ensureProtocol(localStorage.getItem("ipBackend2")) + "/vinculacao/hardware", {
                headers: {
                    Authorization: `${token}`
                },
                params: {
                    codHar: codHar
                }
            });

            if (response.data && response.data.length > 0) {
                const r = response.data[0];
                setCodUsu(r.CODUSU ?? r.codUsu ?? '');
                setNomUsu((r.USRNOMCPL ?? r.usrnomcpl ?? '').toString());
                setSeqVin(r.SEQVIN ?? r.seqVin ?? '');
            }


        } catch (error) {
            console.error('Erro ao buscar dados:', error);
        }
    };

    const verificarCampos = async () => {

        if (obsVin.trim() === '') {
            setMensagem("Atenção deve ser inserido a observação do desvinculo!")
            return;
        }

        if (nomUsu.trim() === '-') {
            setMensagem("Atenção deve ser selecionado um usuário vinculado ao equipamento!");
            return;
        }

        setMensagem("");
    };

    const inserindoHistorico = async () => {

        let desHis = "Desvinculo realizado com usuário:" + codUsu + "\n" + obsVin;

        let codHar = selected;

        verificandoToken();
        const token = localStorage.getItem('token');
        try {
            await axios.post(ensureProtocol(localStorage.getItem("ipBackend2")) + "/hishardware",
                { codHar, desHis },
                {
                    headers: {
                        Authorization: `${token}`
                    }
                });

        } catch (error) {
            setMensagem('Erro ao inserir/atualizar dados');
            setSucesso('N');
        }

    };

    const desvinculo = async () => {

        verificarCampos();
        verificandoToken();

        const token = localStorage.getItem('token');

        try {

            const baseUrl = ensureProtocol(localStorage.getItem("ipBackend2")) + "/vinculacao";
            await axios.delete(`${baseUrl}?seqVin=${encodeURIComponent(seqVin)}`, {
                headers: { Authorization: `${token}` }
            });

            setMensagem('');
            setSucesso('S');

            inserindoHistorico();
        } catch (error) {
            setMensagem('Erro ao inserir/atualizar dados');
            setSucesso('N');
        }
    };

    const verificar = async () => {
        const resultado = await verificandoApp("ATENDENTE");

        if (!resultado) {
            history.push("/");
        }
    };

    useEffect(() => {

        verificar();
        pegarHardware();

        if (props.match.params.id) {
            setSelected(props.match.params.id);
        }

        pegarUsuarios(props.match.params.id);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
            <div className="container-fluid titulo inventario-page">
            <div className="col-4">
                <h1>Realizar Desvinculação</h1>
            </div>
            <form>

                <div className="col">
                    <label htmlFor="exampleInputEmail1">Hardware</label>
                    <select className="form-control disable" disabled={props.match.params.id} value={selected} onChange={(e) => { setSelected(e.target.value); pegarUsuarios(e.target.value); }}>
                        <option value="">Selecione...</option>
                        {data.map((opt) => (
                            <option key={opt.codHar} value={opt.codHar}>
                                {opt.nomEqp + " - " + opt.serEqp + " - " + opt.patEqp}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="col mt-2">
                    <label htmlFor="exampleInputEmail1">Usuário</label>
                    <input type="text" className="form-control disable" placeholder={nomUsu} disabled />
                </div>

                <div className="form-group mb-1 mt-2">
                    <label htmlFor="exampleInputEmail1">Observação da Desvinculação</label>
                    <textarea type="email" className="form-control" rows={5} onChange={(e) => setObsVin(e.target.value)} value={obsVin} id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Registrar Observação de Desvinculação" />
                </div>

                <div className="form-row row mb-1">
                    <div className="form-group col">
                        <label htmlFor="inputEstado">Situação</label>
                        <select id="inputEstado" className="form-control" value={sitVin} onChange={(e) => { setSitVin(e.target.value) }} disabled>
                            <option value={"I"}>Inativo</option>
                        </select>
                    </div>
                </div>


                <button onClick={desvinculo} type="button" className="btn btn-secondary btn-acao mt-4">Salvar</button>
                <Link to="/listaHardware" className="btn btn-outline-secondary btn-acao mt-4 ml-2">Voltar ao Inventário</Link>
            </form>

            {mensagem.length > 0 ? <div className="alert alert-danger mt-2" role="alert">{mensagem}</div> : null}
            {sucesso === 'S' ? <Redirect to='/listaHardware' /> : null}
            </div>
            </main>
        </div>
    );
}

export default NovoDesvinculo;
